import { useMemo } from "react"

import { filter, map } from "lodash-es"
import { useRecoilValue } from "recoil"

import {
  pendingBuddiesSelector,
  reviewedBuddiesSelector,
} from "@fuse/recoil/buddies"

import useFetchSuggestedBuddies from "@fuse/pages/people/controller/useFetchSuggestedBuddies"

const useBuddiesData = () => {
  const pendingBuddies = useRecoilValue(pendingBuddiesSelector)
  const suggestedBuddies = useFetchSuggestedBuddies()
  const realBuddies = useRecoilValue(reviewedBuddiesSelector) || []

  return useMemo(() => {
    // Extract buddy IDs for deduplication
    const realBuddyIds = new Set(map(realBuddies, "buddyId"))
    const pendingBuddyIds = new Set(map(pendingBuddies, "buddyId"))

    // Filter pending buddies (exclude real buddies)
    const filteredPendingBuddies = filter(
      pendingBuddies,
      (buddy) => !realBuddyIds.has(buddy.buddyId),
    )

    // Filter suggested buddies (exclude real and pending buddies)
    const filteredSuggestedBuddies = filter(
      suggestedBuddies,
      (buddy) =>
        !realBuddyIds.has(buddy.uid) && !pendingBuddyIds.has(buddy.uid),
    )

    return {
      realBuddiesSection: realBuddies,
      pendingBuddiesSection: filteredPendingBuddies,
      suggestedBuddiesSection: filteredSuggestedBuddies,
    }
  }, [realBuddies, pendingBuddies, suggestedBuddies])
}

export default useBuddiesData
